import { StyleSheet } from 'aphrodite';
import { navigation } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {},
	header: {
		color: navigation,
		fontSize: 12,
		margin: '12px 0 6px 0',
	},
	info: {
		fontSize: 14,
	},
	inputRow: {
		alignItems: 'center',
		display: 'flex',
		flex: 1,
		flexDirection: 'row',
		margin: '12px 0',
		maxHeight: 35,
	},
	loading: {
		marginTop: 8,
	},
	textBox: {
		background: '#f9f9f9',
		border: '1px solid #ccc',
		borderRadius: 3,
		boxSizing: 'border-box',
		color: '#0d0f11',
		fontSize: 14,
		height: 30,
		marginRight: 8,
		padding: '5px 5px 5px 10px',
		width: '100%',
	},
	useButton: {
		marginTop: 12,
	},
});
